// store/index.js (Vue 3)
import { createStore } from 'vuex'
import VuexPersistence from 'vuex-persist'
import modules from './modules'
import { vuexPersistReducer } from '@/helpers/vuexPersistReducer'

function createQuotaSafeStorage(storage) {
  if (!storage) return null

  return {
    getItem: (key) => storage.getItem(key),
    setItem(key, value) {
      try {
        storage.setItem(key, value)
      } catch (err) {
        console.warn(
          '[vuex-persist] localStorage write skipped:',
          err?.name || err
        )
      }
    },
    removeItem: (key) => storage.removeItem(key),
  }
}

// Optional: guard for SSR or weird browsers
const safeStorage =
  typeof window !== 'undefined'
    ? (() => {
        try {
          const k = '__test__'
          window.localStorage.setItem(k, '1')
          window.localStorage.removeItem(k)
          return createQuotaSafeStorage(window.localStorage)
        } catch {
          return null
        }
      })()
    : null

const vuexLocal = new VuexPersistence({
  key: 'journey_v3',
  storage: safeStorage,
  reducer: vuexPersistReducer,
})

const store = createStore({
  modules,
  actions: {
    reset({ commit }) {
      Object.keys(modules).forEach((moduleName) => {
        commit(`${moduleName}/RESET`)
      })
    },
  },
  strict: process.env.NODE_ENV !== 'production',
  plugins: safeStorage ? [vuexLocal.plugin] : [],
})

export default store
